import axios from 'axios'
import apiUrl from '../../api.config';

const EXAM_ANSWER_API_URL = `${apiUrl}examAnswer`;

const ExamAnswerService = {
    add(examAnswerData) {
        return axios.post(EXAM_ANSWER_API_URL + '/add', examAnswerData, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
}

export default ExamAnswerService;